import React from "react";
import { useLanguage } from "../context/LanguageContext";

export default function AvisAuxUtilisateurs() {
  const { t } = useLanguage();
  const data = t("pages.avis") || t("pages.avisAuxUtilisateurs");

  if (!data) return null;

  return (
    <section className="bg-gradient-to-b from-[#071026] via-[#08101d] to-[#070b12] text-slate-100">
      <div className="py-16 sm:py-20">
        <div className="max-w-4xl mx-auto px-5 sm:px-8">
          <div className="bg-white/95 dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-2xl shadow-sm p-6">
            <h1 className="text-3xl font-semibold mb-2 text-slate-900 dark:text-slate-100">
              {data.title}
            </h1>

            {data.subtitle && (
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
                {data.subtitle}
              </p>
            )}

            {data.lines && (
              <div className="mt-6 space-y-4 text-gray-800 dark:text-gray-200 leading-relaxed">
                {data.lines.map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
              </div>
            )}

            {data.items && (
              <ul className="list-disc list-inside space-y-3 text-gray-800 dark:text-gray-200">
                {data.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}

            {data.cancellation && (
              <div className="mt-6 p-4 rounded-md bg-yellow-50 dark:bg-yellow-900 border-l-4 border-yellow-400 dark:border-yellow-600 text-sm text-yellow-800 dark:text-yellow-100">
                <div className="font-semibold">{data.cancellation}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
